import styled from "styled-components";
import { responsive } from "../../../../../styles/constants.style";

export const BillingTypeFieldWrapper = styled.div`
  .form-field-normal {
    &:nth-child(-n + 3) {
      margin-top: 24px;
    }
    &:nth-child(n + 4) {
      margin-top: 40px;
    }
    &.inner {
      margin-top: 24px;
    }

    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 40px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}

    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 16px;
      }
      &:nth-child(n+2) {
        margin-top: 16px;
      }
    `}
  }
  .form-field-override {
    &:nth-child(-n + 3) {
      margin-top: 40px;
      ${responsive.TABLET_LANDSCAPE`
         margin-top: 16px;
      `}
    }
    &:nth-child(n + 4) {
      margin-top: 40px;
      ${responsive.TABLET_LANDSCAPE`
         margin-top: 0;
      `}
    }
    &.inner {
      margin-top: 24px;
    }

    ${responsive.TABLET_PORTRAIT`
      &:nth-child(1), &:nth-child(2) {
        margin-top: 40px;
      }
      &:nth-child(n+3) {
        margin-top: 40px;
      }
    `}

    ${responsive.MOBILE`
      &:nth-child(1) {
        margin-top: 16px;
      }
      &:nth-child(n+2) {
        margin-top: 16px;
      }
    `}
  }
  .config-header {
    margin-top: 24px;
  }
`;
